export default __webpack_public_path__ + "static/media/gallery_01.3a6dc284.jpg";